import React, { useState } from 'react';

export default function NavbarComponent() {
  const navItems = [
    { label: "Work", id: "branding" },
    { label: "About", id: "firstpage" },
    { label: "Contact", id: "contact" },
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <>
      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        html {
          scroll-behavior: smooth;
        }

        body {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        }

        .navbar-container {
          padding: 24px 48px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          backdrop-filter: blur(60px);
        }

        .brand {
          font-weight: 500;
          font-size: 18px;
          line-height: 1.4;
          text-decoration: none;
          color: inherit;
          cursor: pointer;
          transition: opacity 0.3s ease;
        }

        .brand:hover {
          opacity: 0.7;
        }

        .capsule-nav {
          position: relative;
          display: flex;
          background: #ffffff;
          padding: 4px;
          border-radius: 50px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.08);
        }

        .indicator {
          position: absolute;
          top: 4px;
          left: 4px;
          width: 110px;
          height: 42px;
          background: #000;
          border-radius: 40px;
          transition: transform 0.35s ease;
          z-index: 0;
        }

        .nav-btn {
          position: relative;
          z-index: 1;
          width: 110px;
          text-align: center;
          padding: 10px 0;
          text-decoration: none;
          font-size: 16px;
          font-weight: 500;
          color: #000;
          cursor: pointer;
          transition: color 0.3s ease;
        }

        .nav-btn.active {
          color: #fff;
        }
      `}</style>

      <div className="navbar-container">
        {/* Brand → About section */}
        <a href="#firstpage" className="brand">
          <div>JOSEPH</div>
          <div>VITHAYATHIL</div>
        </a>

        {/* Capsule Navigation */}
        <div className="capsule-nav">
          <div
            className="indicator"
            style={{
              transform: `translateX(${activeIndex * 110}px)`
            }}
          />

          {navItems.map((item, index) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`nav-btn ${activeIndex === index ? "active" : ""}`}
              onClick={() => setActiveIndex(index)}
            >
              {item.label}
            </a>
          ))}
        </div>

        {/* Logo → Scroll to Top */}
        <img
          src="/logo.png"
          alt="Logo"
          style={{ width: 46, height: 46, cursor: 'pointer',marginRight:'60px' }}
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        />
      </div>
    </>
  );
}
